// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'mint-ui/lib/style.css'
import '@/assets/pc/pc.less'

import Vue from 'vue'
import App from './App'
import router from './router'
import MintUI from 'mint-ui'
import VueClipboard from 'vue-clipboard2'

import store from './config/store'

Vue.use(MintUI);
Vue.use(VueClipboard);
//Vue.config.productionTip = false;
Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: '#contents',
  store,
  router,
  render: h => h(App)
});

// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   next()
// })



// WEBPACK FOOTER //
// ./src/main.js